
import {type PlanType} from 'src/modules/user/subscription/SubscriptionService'

type WichItem = PlanType | 'all'
export class CurrentPromotion {
  startDate: Date
  endDate: Date
  endDateString: {
    fr: string
    en: string
  }
  value: number
  code: string
  localStoragePromotionName?: string
  wichItems: WichItem[]

  constructor(value: number, code: string, startDate: Date = new Date(), endDate: Date = new Date(), endDateString = {fr: '', en: ''}, localStoragePromotionName?: string, wichItems: WichItem[] = ['all']) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.endDateString = endDateString;
    this.value = value;
    this.code = code;
    this.localStoragePromotionName = localStoragePromotionName;
    this.wichItems = wichItems
  }

  get isInProgress() {
    const currentDate = new Date().getTime()
    return ((currentDate <= this.endDate.getTime()) && (currentDate >= this.startDate.getTime())) || (this.startDate.getTime() === this.endDate.getTime())
  }

  get isPopupAndChipDisplayed() {
    return !!this.localStoragePromotionName
  }

  get isSuperPromotion() {
    return this.value === 70;
  }
}

/*
Example : 
  new CurrentPromotion(
    40,
    'PIANO2025',
    new Date('01/11/2025 00:00'),
    new Date('02/28/2025 23:59'),
    '28 Février',
    'firstPromo2025'
  )

  //localstorageHistory:
  - 'firstPromo2025'
*/
export const currentPromotion: CurrentPromotion | null = new CurrentPromotion(
  70,
  '21JUIN',
  new Date('06/13/2026 00:00'),
  new Date('06/30/2026 23:59'),
  {fr: '30 juin', en: 'June 30th'},
  'promoJune2026',
  ['annual', 'lifetime']
)